module.exports = __webpack_public_path__ + "media/img/corporate/logos/accenture-fd9f3950041851fe0de9f75d3cc689f2.svg";